<template>
<div class="ucp__menu">
  <div class="ucp__maintitle">Меню</div>
  <div class="ucp__formsubtitle">Личный ящик</div>
  <p>
    <img src="../assets/nav_m_dark.gif"> <a><b>Новое личное сообщение</b></a><br>
    <span v-html="nbsp"></span><span v-html="nbsp"></span> <img src="../assets/msg_folder.gif"> <a href="index.php?act=Msg">Inbox
      <template v-if="inbox > 0">
        ({{inbox}})
      </template>
    </a><br>
    <span v-html="nbsp"></span><span v-html="nbsp"></span> <img src="../assets/msg_folder.gif"> <a href="index.php?act=Msg&VID=sent">Sent Items
      <template v-if="outbox > 0">
        ({{outbox}})
      </template>
    </a><br>
    <span v-html="nbsp"></span><span v-html="nbsp"></span> <img src="../assets/msg_folder.gif"> <a href="index.php?act=Msg&VID=unsent">Неотправленные
      <template v-if="unsent > 0">
        ({{unsent}})
      </template>
    </a><br>
    <img src="../assets/nav_m_dark.gif"> <a>Очистка папок</a><br>
    <img src="../assets/nav_m_dark.gif"> <a>Редактировать папки</a><br>
    <img src="../assets/nav_m_dark.gif"> <a>Список контактов</a><br>
    <img src="../assets/nav_m_dark.gif"> <a>Архивирование сообщений</a><br>
    <img src="../assets/nav_m_dark.gif"> <a>Слежение за сообщениями</a><br>
  </p>

  <div class="ucp__formsubtitle">Подписки</div>
  <p>
    <img src="../assets/nav_m_dark.gif"> <a>Темы</a><br>
    <img src="../assets/nav_m_dark.gif"> <a>Форумы</a><br>
  </p>

  <div class="ucp__formsubtitle">Ваш профиль</div>
  <p>
    <img src="../assets/nav_m_dark.gif"> <a>Изменить личные данные</a><br>
    <img src="../assets/nav_m_dark.gif"> <a>Изменить подпись</a><br>
    <img src="../assets/nav_m_dark.gif"> <a>Установка аватара</a><br>
    <img src="../assets/nav_m_dark.gif"> <a>Установка фотографии</a><br>
  </p>

  <div class="ucp__formsubtitle">Настройки</div>
  <p>
    <img src="../assets/nav_m_dark.gif"> <a>Прикрепленные файлы (attach'и)</a><br>
    <img src="../assets/nav_m_dark.gif"> <a>Игнорирование пользователей</a><br>
    <img src="../assets/nav_m_dark.gif"> <a>Настройки e-mail</a><br>
    <img src="../assets/nav_m_dark.gif"> <a>Настройки форума</a><br>
    <img src="../assets/nav_m_dark.gif"> <a>Изменить E-mail</a><br>
    <img src="../assets/nav_m_dark.gif"> <a>Изменить пароль</a><br>
  </p>

</div>
</template>

<script>
export default {
  props: ['inbox', 'outbox', 'unsent'], // now use {{breadcrumbs}}
}
</script>

<style lang="scss">
.ucp__menu {
    background: #1E2C38;
    border: 1px solid #000;
    line-height: 150%;
    p {
        margin: 0;
        padding: 2px 5px 6px 9px;
    }
}
.ucp__maintitle {
    background: transparent url("../assets/tile_cat.gif");
    border: 1px solid #546971;
    border-bottom: 1px solid #000;
    font-size: 11px;
    font-weight: bold;
    margin: 0;
    padding: 8px;
}
.ucp__formsubtitle {
    font-weight: bold;
    padding: 5px;
    font-size: 11px;
    background: #2D4150;
}
</style>
